import Accordion from '@/common/components/Accordion'
import HighlightTextArea from '@/common/components/HighlightTextArea'
import TextField from '@/common/components/TextField'
import { fiscalDocumentKindStrategy } from '@/features/privateCompanies/constants/fiscalDocumentKind.constant'
import { FiscalDocumentInformationData } from '@/features/privateCompanies/types/companyBranches.type'
import { AvailableTokensAccordion } from '@/common/components/AvailableTokensAccordion'
import { useBillingBillsDescriptionTokens } from '@/common/hooks/queries/useBillingBillsDescriptionTokens'
import { Mapper } from '@/common/services/mapper'
import { BillingBillsDescriptionTokensTransformer } from '../../services/billingBillsDescriptionTokensTransformer'

interface FiscalDocumentInformationProps {
  fiscal_document_information?: FiscalDocumentInformationData
}

export const FiscalDocumentInformation = ({ fiscal_document_information }: FiscalDocumentInformationProps) => {
  const { data: descriptionTokens, dataUpdatedAt } = useBillingBillsDescriptionTokens({
    mapper: Mapper.mapWithTransformer({ transformer: BillingBillsDescriptionTokensTransformer.suggestionsTransformer() })
  });

  return (
    <Accordion
      className="py-1"
      name="fiscal_document_information"
      head={<p>Detalhes Fiscais</p>}
      body={
        <div className="flex flex-col gap-4">
          <TextField
            name="fiscal_document_information_fiscal_document_kind"
            label="Tipo de Documento Fiscal"
            value={
              fiscal_document_information?.fiscal_document_kind
                ? fiscalDocumentKindStrategy[
                fiscal_document_information.fiscal_document_kind as keyof typeof fiscalDocumentKindStrategy
                ]
                : ''
            }
            disabled
          />

          <HighlightTextArea
            label="NF de Consumo"
            rows={16}
            maxLength={1024}
            name="fiscal_document_information_consumption_observations"
            value={fiscal_document_information?.consumption_observations}
            disabled
            suggestions={descriptionTokens}
          />

          <HighlightTextArea
            label="NF de Tarifas"
            rows={16}
            maxLength={1024}
            name="fiscal_document_information_service_observations"
            value={fiscal_document_information?.service_observations as string | undefined}
            disabled
            suggestions={descriptionTokens}
          />

          <AvailableTokensAccordion descriptionTokens={descriptionTokens} updatedAt={dataUpdatedAt} />
        </div>
      }
    />
  )
}
